import React, { Component } from 'react';
import { connect } from 'react-redux';
import NavigationBars from '../../components/HOC/withNavigationBars';
import actions from './duck/actions';
import ChildTable from './ChildTable';
import { Breadcrumbs } from 'kangarootime-ui';
import LightboxPhoto from '../../components/LightboxPhoto';

class RoomGallery extends Component {
  constructor (props) {
    super(props);

    this.state = {
      orderTableBy: 'numberOfPhotosTakenToday',
      order: 'asc',
      lightboxOpen: false,
      lightboxPhotoUri: ''
    };
  }

  get roomId () {
    return this.props.match.params.room_id;
  }

  get roomName () {
    const { roomNames } = this.props;

    if (roomNames) {
      return roomNames[this.roomId];
    }

    return 'Room';
  }

  get childrenToShow () {
    const { galleriesByRoom } = this.props;

    if (galleriesByRoom && galleriesByRoom[this.roomId]) {
      return galleriesByRoom[this.roomId];
    }

    return [];
  }

  get breadcrumbs () {
    return [
      { label: 'Dashboard', link: null },
      { label: this.roomName, link: null }
    ];
  }

  componentDidMount = () => {
    if (this.roomId) {
      this.props.getGalleryInformationForRoom(this.roomId);
    }
  }

  selectChildGallery = childId => {
    const child = this.childrenToShow.filter(child => child.child_id === childId)[0];

    this.props.history.push(`/gallery/room/${this.roomId}/child/${childId}`, {
      childId,
      child,
      roomId: this.roomId,
      roomName: this.roomName
    });
  }

  handleTableSortRequest = (event, property) => {
    const orderTableBy = property;
    let order = 'desc';

    if (this.state.orderTableBy === property && this.state.order === 'desc') {
      order = 'asc';
    }

    this.setState({ order, orderTableBy });
  }

  render () {
    const { galleriesByRoom } = this.props;
    const { orderTableBy, order } = this.state;
    // room isn't in redux so it hasn't been fetched, show the loader
    const isLoading = galleriesByRoom[this.roomId] === undefined;

    return (
      <NavigationBars>
        <div className='flex-1 flex-columns'>
          <Breadcrumbs breadcrumbs={this.breadcrumbs} />
          <ChildTable
            rows={this.childrenToShow}
            selectRow={this.selectChildGallery}
            loading={isLoading}
            order={order}
            orderBy={orderTableBy}
            onRequestSort={this.handleTableSortRequest}
            selectPhotoTakenToday={photo => this.setState({ lightboxOpen: true, lightboxPhotoUri: photo.image })}
          />
          <LightboxPhoto
            isOpen={this.state.lightboxOpen}
            imageUrl={this.state.lightboxPhotoUri}
            onClose={() => this.setState({ lightboxOpen: false, lightboxPhotoUri: '' })}
          />
        </div>
      </NavigationBars>
    );
  }
}

function mapStateToProps (state) {
  return {
    galleriesByRoom: state.gallery.byRoom.roomGalleryInformation,
    roomNames: state.rooms.roomNames
  };
}

function mapDispatchToProps (dispatch) {
  return {
    getGalleryInformationForRoom: roomId => dispatch(actions.getRoomGalleryRequest(roomId))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RoomGallery);
